module.exports = __webpack_public_path__ + "static/media/integrated_id.3fde2f96.svg";